"use client";
import XMarkIcon from "@heroicons/react/24/outline/XMarkIcon";
import SmallLogo from "@/components/SmallLogo";
import { useTranslation } from "@/hooks/translationContext";

function SideBarHeader({ onClose }: { onClose: () => void }) {
  const { t } = useTranslation()

  return (
    <header className="flex justify-between items-center py-2 shrink-0">
      <div className="py-[6.5px]">
        <SmallLogo />
      </div>

      <div className="flex gap-2 items-center justify-end md:w-full">
        <span className="text-gray-400 text-[10px] font-medium">
          {t("modal-short-title", { defaultValue: "Yüzlerce Mekan Burada" })}
        </span>
        <button onClick={() => onClose()}>
          <XMarkIcon className="size-8 text-assistant cursor-pointer" />
        </button>
      </div>
    </header>
  );
}

export default SideBarHeader;
